import clsx from 'clsx';
import Link from 'next/link';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/shadcn/components/Table';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetsTable = _ref => {
  let {
    className = '',
    widgets
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    className: clsx('py-32', className),
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "grid gap-10 lg:grid-cols-4 lg:gap-20",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "row-span-2 text-3xl font-semibold",
          children: "A template for every use case"
        }), /*#__PURE__*/_jsx("div", {
          className: "col-span-3",
          children: /*#__PURE__*/_jsxs(Table, {
            children: [/*#__PURE__*/_jsx(TableHeader, {
              children: /*#__PURE__*/_jsxs(TableRow, {
                children: [/*#__PURE__*/_jsx(TableHead, {
                  children: "Name"
                }), /*#__PURE__*/_jsx(TableHead, {
                  className: "text-right",
                  children: "Preview"
                })]
              })
            }), /*#__PURE__*/_jsx(TableBody, {
              children: widgets === null || widgets === void 0 ? void 0 : widgets.map(widget => /*#__PURE__*/_jsxs(TableRow, {
                children: [/*#__PURE__*/_jsx(TableCell, {
                  className: "font-medium",
                  children: widget.title
                }), /*#__PURE__*/_jsx(TableCell, {
                  className: "text-right",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: `/templates/${widget.slug}`,
                    children: "View Now \u279D"
                  })
                })]
              }, widget.id))
            })]
          })
        })]
      })
    })
  });
};
export default WidgetsTable;